export default __webpack_public_path__ + "static/media/defient-stack1.webp";